(function () {
  let lock = false;

  function enforceInStockWhenSizeSelected() {
    if (lock) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;

    const hasSize =
      params.has("filter.v.option.size") ||
      params.has("filter.p.option.size");

    const hasAvailability =
      params.has("filter.v.availability") ||
      params.has("filter.p.availability");

    // Only enforce when a size is selected but availability isn't
    if (hasSize && !hasAvailability) {
      lock = true;

      // Your store uses filter.v.availability=1
      params.set("filter.v.availability", "1");
      url.search = params.toString();

      // Force navigation so Ella re-renders correctly
      window.location.assign(url.toString());
    }
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", enforceInStockWhenSizeSelected);

  // Catch clicks (Ella uses buttons/links often)
  document.addEventListener(
    "click",
    function () {
      // Let Ella update the URL first, then enforce
      setTimeout(enforceInStockWhenSizeSelected, 50);
    },
    true
  );

  // Catch browser back/forward
  window.addEventListener("popstate", function () {
    setTimeout(enforceInStockWhenSizeSelected, 50);
  });

  // Catch Ella AJAX URL changes (pushState/replaceState)
  (function (history) {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    history.pushState = function () {
      const ret = pushState.apply(this, arguments);
      setTimeout(enforceInStockWhenSizeSelected, 50);
      return ret;
    };

    history.replaceState = function () {
      const ret = replaceState.apply(this, arguments);
      setTimeout(enforceInStockWhenSizeSelected, 50);
      return ret;
    };
  })(window.history);
})();